<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Fleet Departure</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexport"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >
                Export
              </button>
            </div>
            <b-row>
              <b-col md="3" class="my-1">
                <!--<b-progress height="2px" :value="progressCap" variant="primary" class="mt-2"></b-progress>-->
                <br />
                <b-form-group label-cols-sm="1" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search.." />
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> </b-row
            >&nbsp;
            <b-table
              show-empty
              bordered
              responsive="sm"
              
              stacked="md"
              hover
              small
              striped
              head-variant="light"
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Action)="data">
                <b-button
                  type="button"
                  class="btn btn-sm btn-info"
                  @click="
                    toDepart(
                      data.item.fleetregistryId,
                      data.item.plateno,
                      data.item.refdocument
                    )
                  "
                >
                  <i class="fa fa-pencil-square-o"
                    >&nbsp;Departure</i
                  > </b-button
                >&nbsp;
              </template>
              <!-- <template v-slot:cell(arrivaldatetime)="data">
                <div>
                  <span>{{data.item.arrivaldatetime }}</span>
                </div>
              </template> -->
            </b-table>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              >
              </b-pagination>
            </div>
          </b-card>
        </div>

        <div class="dispatch-list">
          <b-list-group v-for="(item,index) in items" :key="`dynlist-${index}`" class="shadow">
            <b-list-group-item class="flex-column align-items-start">
              <div class="list-field">
                <span class="mb-1 dis">Plateno:{{item.plateno}}</span>
              </div>
              <div class="list-field">
                <span>Licenseno:{{item.licenseno}}</span>
              </div>
              <div class="list-field">
                <span>ADT: {{item.arrivaldatetime | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}</span>
              </div>
              <div class="row">
                <div class="col">
                  <div style="text-align:center;">
                    <router-link tag="button" :to="'/Activity/2017060610325948/departure-setup/' + item.fleetregistryId"
                      class="btn btn-primary btn-sm btn-block">
                      <i class="fa fa-pencil-square-o"></i>
                      Departure
                    </router-link>
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>

        <b-modal
          title="System Message"
          v-model="deleteModal"
          @ok="onDeleteItem"
        >
          Are you sure you want to remove
          <strong>{{ selectedItemLabel }} ?</strong>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from "../../../services/api";
import JSONToCSVConvertor from "../../../services/JSONToCSVConvertor.js";
import axios from "axios";
import moment from "moment";

export default {
  data: function () {
    return {
      progressCap: null,
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",
      selectedfile: null,
      perPage: this.$store.getters.perPage,
      totalItem: 0,
      currentPage: 1,
      isBusy: false,
      filter: null,
      fields: [
        {
          key: "Action",
          sortable: false,
        },
        {
          key: "fleetregistryId",
          label: "ID",
          sortable: true,
        },
        {
          key: "plateno",
          label: "Plate Number",
          sortable: true,
        },
        {
          key: "licenseno",
          label: "License Number",
          sortable: true,
        },
        {
          key: "parkinglane",
          label: "Lane No",
          sortable: true,
        },
        {
          key: "lanetype",
          label: "Trans Type",
          sortable: true,
        },
        {
          key: "scancode",
          label: "Barcode",
          sortable: true,
        },
        {
          key: "refdocument",
          label: "Document",
          sortable: true,
        },
        {
          key: "arrivaldatetime",
          label: "ADT",
          sortable: true,
          formatter: "DateConvertFooter",
        },
        {
          key: "departuredatetime",
          label: "DDT",
          sortable: true,
          formatter: "DateConvertFooter",
        },

        {
          key: "remarks",
          label: "Remarks",
          sortable: true,
        },
      ],
      items: [],
    };
  },

  computed: {
    // filter() {
    //   this.currentPage = 1;
    //   this.totalrows = this.items.length;
    // },

    rows() {
      return this.items.length;
    },
  },

  methods: {
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onexport: function () {
      JSONToCSVConvertor(this.items, "Fleet Departure", true);
    },

    onfileselected(event) {
      this.selectedfile = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.selectedfile);
      reader.onload = function () {
        console.log(reader.result.split(",")[1]);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },

    onUpload() {
      const imageToUri = require("image-to-uri");
      var imageAsBase64 = imageToUri(this.selectedfile);
      const evt = new FormData();
      evt.append("image", imageAsBase64);
      evt.append("origfilename", this.selectedfile.name);
      evt.append("extension", ".png");
      api.instance
        .post("wfms/UploadCustomerImage", evt, {
          onUploadProgress: (uploadEvent) => {
            this.progressCap = Math.round(
              (uploadEvent.loaded / uploadEvent.total) * 100
            );
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    initTable() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-trans-activity?brancode=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          self.totalItem = resp.data.totalItem;
          console.log("depart", resp.data);
          self.$store.commit("setLoading", false);
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          //   return items;
        })
        .catch((err) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    // onPageSelect(page) {
    //   this.isBusy = true;
    //   let self = this;
    //   self.$store.commit("setLoading", true);
    //   axios
    //     .get(
    //       this.$store.state.IFMSlocalURL +
    //       "get-trans-activity?brancode=" +
    //       self.$store.state.selectedWarehouse
    //     )
    //     .then(resp => {
    //       self.items = resp.data;
    //       self.totalItem = resp.data.totalItem;

    //       self.$store.commit("setLoading", false);
    //       // Here we could override the busy state, setting isBusy to false
    //       self.isBusy = false;
    //     })
    //     .catch(err => {
    //       // Here we could override the busy state, setting isBusy to false
    //       self.isBusy = false;
    //       api.httpMsg(self, err.status, err.data);
    //       self.$store.commit("setLoading", false);
    //       // Returning an empty array, allows table to correctly handle busy state in case of error
    //       return [];
    //     });
    // },

    onSelecteItemToDelete: function (param) {
      this.selectedItem = param;
      this.selectedItemLabel = this.selectedItem.fleetregistryId;
      this.deleteModal = true;
    },

    onDeleteItem: function () {
      this.$store.commit("setLoading", true);
      api.instance
        .delete(
          this.$store.state.IFMSURLlocal +
            "remove-fleet-registry?fleetregistryId=" +
            this.selectedItem.fleetregistryId
        )
        .then((resp) => {
          this.initTable();
          this.deleteModal = false;
          this.$store.commit("setLoading", false);
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
        });
    },

    toDepart(fleetid, plateno, doc) {
      (this.$store.state.fleetId = fleetid),
        (this.$store.state.plateNo = plateno),
        (this.$store.state.refDoc = doc);
      this.$router.push("/Activity/2017060610325948/departure-setup/");
    },

    DateConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("MM-DD-YYYY, h:mm a");
      }
    },
  },
  created: function () {
    this.initTable();
  },
};
</script>